module.exports = __webpack_public_path__ + "static/media/TommyHoodLabels.7107fd1d.png";